module.exports = __webpack_public_path__ + "static/media/google-play-services.857a41fd.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/Portfolio/images/platforms/google-play-services.png
 ** module id = 223
 ** module chunks = 0
 **/